<app-banner [heading]="'OUR INFRA - MUSIC STUDIO'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/musicstudio/music-studio-1.jpg" alt="best school in kurukshetra">
            </div>
			<div class="about-img">
              <img src="assets/img/infra/musicstudio/music-studio-2.jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-lg-8 col-md-6">
            <div class="about-content">
              <h6 class=""> Music Studio</h6>
              
              <p>Music is a unique way of communicating that can inspire, motivate children and reflects
			  the culture and society we live in and so learning of music enables children to better
			  understand the world they live in, besides music is a creative and enjoyable activity too.<br><br>
              Here in Tagore Global School, we work to nurture in our students the appropriate values and attitudes
			  in learning music, and in doing so, we promote the highest levels of human aspiration and 
			  artistic integrity through the various ways performance of music.<br><br>
			  The studio includes separate rooms for Vocals, Drums, Guitar and Keyboard, thereby enabling 
			  students to enjoy their learning and practice whenever required.
			  
			  </p>
              
            </div>
          </div>
		  
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/musicstudio/music-studio-6.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/musicstudio/music-studio-7.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-4 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/musicstudio/music-studio-8.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 
		  
		</div>
      </div>
	</section><!-- End About Section -->

	
	
    
    
  </main>